module.exports = __webpack_public_path__ + "img/20220330.af0ca4eb.jpg";